class Header {
	public key: string;
	public value: string;
};

class Request {
	public method: string;
	public url: string;
	public headers?: Header[];
	public payload?: string;
};

class Response {
	public status: number;
	public message: string;
	public headers?: Header[];
	public payload?: string;
};

export class AccountingAuditModel {
	public id: string;
	public isWebhook: boolean;
	public timestamp: Date;
	public duration: number;
	public request: Request;
	public response: Response;
	public wasSuccessful: boolean;

	constructor(json?: Partial<AccountingAuditModel>) {
		if (json) {
			Object.assign(this, json);
		}
	}
}
